import React from 'react';
import { HStack, CloseButtonProps, CloseButton, classnames } from '@cad-arc';
import { CadNextNotificationPriorityEnumType } from '@mark43/cad-api';
import { eventNotificationPriorityToColors } from '../event-notifications/event-notifications';
import { WorkspacePanel } from './workspace-panel';

export const PanelHeader = React.forwardRef<
    HTMLDivElement,
    React.ComponentProps<'div'> & {
        panel: WorkspacePanel;
        onClose?: () => void;
        // I think this should be removed if we establish a standard for panel header buttons.
        closeButtonProps?: CloseButtonProps;
        highestNotificationPriority?: CadNextNotificationPriorityEnumType;
    }
>(
    (
        {
            panel,
            onMouseDown,
            onClose,
            closeButtonProps,
            children,
            highestNotificationPriority,
            ...rest
        },
        ref
    ) => {
        const borderBottom = highestNotificationPriority ? 'md' : 'sm';
        const borderColor = highestNotificationPriority
            ? eventNotificationPriorityToColors[highestNotificationPriority].notchOrText
            : 'border.default';


        return (
            <HStack
                align="start"
                className={classnames('drag-handle', {'arc-blink-bg': panel.isAlerting})}
                cursor="move"
                backgroundColor={panel.isAlerting ? undefined : "surface.foreground"}
                justifyContent="space-between"
                padding={1}
                spacing={2}
                ref={ref}
                {...rest}
                onMouseDown={(e) => {
                    onMouseDown?.(e);
                }}
                data-workspace-panel-type={panel.workspacePanelType}
                borderBottom={borderBottom}
                borderColor={borderColor}
                borderRadius="inherit"
                borderBottomRadius="0"
            >
                {children}
                <CloseButton
                    size="md"
                    onClick={() => {
                        panel.close(onClose);
                    }}
                    aria-label="close"
                    color="brand.default"
                    {...closeButtonProps}
                />
            </HStack>
        );
    }
);
